import { connect } from 'react-redux';
import UserGroupMembers from './UserGroupMembers';

const mapStateToProps = state => ({
  isLoading: state.userGroups.members.isLoading,
  userGroupId: state.userGroups.details.userGroup.id,
  userGroupExternalId: state.userGroups.details.userGroup?.attributes.external_id,
  isSamlEnabled: state.authSettings.organization.saml.enabled,
  isAutoProvisioningEnabled: state.authSettings.organization.autoProvisioning.enabled,
  members: state.userGroups.members.members,
  failed: state.userGroups.members.failed,
  total: state.userGroups.members.total,
});

export default connect(mapStateToProps)(UserGroupMembers);
